import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import messages from './messages'

const AccountCodeCorrectionViewChunk = React.lazy(() =>
  import('../../feature-sets/AccountCodeCorrectionView').then(
    ({ AccountCodeCorrectionView }) => ({
      default: AccountCodeCorrectionView,
    })
  )
)

export const AccountCodeCorrectionPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.accountCodeCorrectionTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.accountCodeCorrectionTitle),
        },
      ]}
    >
      <React.Suspense fallback={null}>
        <AccountCodeCorrectionViewChunk />
      </React.Suspense>
    </Page>
  )
}
